"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Loading = _interopRequireDefault(require("../Loading"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var UTLoading = function UTLoading(_ref) {
  var loading = _ref.loading,
      text = _ref.text,
      className = _ref.className,
      children = _ref.children,
      thickness = _ref.thickness,
      size = _ref.size,
      preventUnmount = _ref.preventUnmount,
      textClassName = _ref.textClassName;
  return _react["default"].createElement(_react.Fragment, null, loading && _react["default"].createElement(_Loading["default"], {
    text: text,
    className: className,
    thickness: thickness,
    size: size,
    textClassName: textClassName
  }), preventUnmount ? _react["default"].createElement("div", {
    style: loading ? {
      display: 'none'
    } : {}
  }, children) : !loading && children);
};

UTLoading.defaultProps = {
  preventUnmount: false
};
UTLoading.propTypes = {
  loading: _propTypes.bool,
  text: _propTypes.string,
  className: _propTypes.string,
  textClassName: _propTypes.string,
  preventUnmount: _propTypes.bool,
  size: _propTypes.number,
  thickness: _propTypes.number
};
var _default = UTLoading;
exports["default"] = _default;